import {
  useContextStore,
  useContextStoreApi
} from '@eastcoal/common/utils/zustand'

import { MemberDeptUserStoreContext } from '../contexts/StoreContext'
import { MemberDeptUserStore } from '../store/interface'

export const useMemberDeptUserStore = <M extends boolean, StateSlice>(
  selector: (store: MemberDeptUserStore<M>) => StateSlice
) => {
  return useContextStore<MemberDeptUserStore<M>, StateSlice>(
    MemberDeptUserStoreContext as any,
    selector
  )
}

export const useMemberDeptUserStoreApi = <M>() => {
  return useContextStoreApi<MemberDeptUserStore<M>>(
    MemberDeptUserStoreContext as any
  )
}
